const shopifySections = document.querySelectorAll(".shopify-section");

shopifySections.forEach(section => {
  const dogMascots = section.querySelectorAll(".dog-mascot .sticker__translate-container");
  const catMascots = section.querySelectorAll(".cat-mascot .sticker__translate-container");

  // Initialize stickers off-screen
  dogMascots.forEach(dog => {
    dog.style.setProperty("transform", "translate(0%, -100%)", "important");
    dog.style.setProperty("transition", "transform 0.1s linear", "important");
    dog.closest('.dog-mascot').style.setProperty("overflow","hidden")
  });
  catMascots.forEach(cat => {
    cat.style.setProperty("transform", "translate(0%, 100%)", "important");
    cat.style.setProperty("transition", "transform 0.1s linear", "important");
    cat.closest('.cat-mascot').style.setProperty("overflow","hidden")

  });

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const scrollHandler = () => {
          const sectionRect = section.getBoundingClientRect();
          const windowHeight = window.innerHeight;

          
          const dogRevealPoint = 0.5; 
          const catRevealPoint = 0.25;

          // Dog progress: based on section TOP entering viewport
          let dogProgress = (windowHeight - sectionRect.top) / (windowHeight * dogRevealPoint);
          dogProgress = Math.min(Math.max(dogProgress, 0), 1);

          // Cat progress: based on section BOTTOM entering viewport
          let catProgress = (windowHeight - sectionRect.bottom) / (windowHeight * catRevealPoint);
          catProgress = Math.min(Math.max(catProgress, 0), 1);

          // Dog mascots: -100% → 0%
          dogMascots.forEach(dog => {
            const translateY = -100 + dogProgress * 100;
            dog.style.setProperty("transform", `translate(0%, ${translateY}%)`, "important");
          });

          // Cat mascots: 100% → 8%
          catMascots.forEach(cat => {
            const translateY = 100 - catProgress * (100 - 5);
            cat.style.setProperty("transform", `translate(0%, ${translateY}%)`, "important");
          });
        };

        window.addEventListener("scroll", scrollHandler, { passive: true });
        scrollHandler();
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0 });

  observer.observe(section);
});